<template>
    <!-- begin sidebar nav -->
    <div class="menu" v-if="menus">
        <div class="menu-search mb-n3" v-if="appOptions.appSidebarSearch">
           <div class="menu-search">
                <div class="input-group">
                <input
                    type="text"
                    v-on:keyup.enter="handleSidebarFilter"
                    class="form-control"
                    :placeholder="$t('menu.search')"
                    v-on:blur="handleCollapNav"
                    ref="sidebarSearch"
                    autocomplete="off"
                    v-model="searchMenu"
                />
                <button
                    type="button"
                    @click="handleSidebarFilter"
                    class="btn btn-outline-secondary"
                >
                    <i class="fa fa-search fa-fw"></i>
                </button>
                </div>
            </div>
        </div>
        <template v-for="menu in favoritesMenus">
            <sidebar-nav-list
                class="pt-2"
                v-bind:menu="menu"
                v-bind:scrollTop="scrollTop"
                v-bind:key="menu.path"
                v-bind:status="menu.status"
                v-on:collapse-other="handleCollapseOther(menu)"
                v-on:show-float-submenu="handleShowFloatSubmenu"
                v-on:hide-float-submenu="handleHideFloatSubmenu"
            ></sidebar-nav-list>
        </template>

        <div class="menu-header">{{ $t('menu.navigation') }}</div>
        <template v-for="menu in menus">
            <sidebar-nav-list
                ref="sidebarNavList"
                v-bind:menu="menu"
                v-bind:scrollTop="scrollTop"
                v-bind:key="menu.path"
                v-bind:status="menu.status"
                v-on:collapse-other="handleCollapseOther(menu)"
                v-on:show-float-submenu="handleShowFloatSubmenu"
                v-on:hide-float-submenu="handleHideFloatSubmenu"
            ></sidebar-nav-list>
        </template>

        <!-- BEGIN minify-button -->
        <div class="menu-item d-flex">
            <a
                href="javascript:;"
                class="app-sidebar-minify-btn ms-auto"
                v-on:click="handleSidebarMinify()"
                ><i class="fa fa-angle-double-left"></i
            ></a>
        </div>
        <!-- END minify-button -->
    </div>
    <!-- end sidebar nav -->
</template>

<script>
import SidebarMenu from './SidebarMenu.vue'
import SidebarNavList from './SidebarNavList.vue'
import AppOptions from '../../config/AppOptions.vue'

export default {
    name: 'SidebarNav',
    props: ['scrollTop'],
    components: {
        SidebarNavList
    },
    mounted() {
        this.$refs.sidebarSearch.setAttribute('autocomplete', 'off')
        setTimeout(() => {
        this.$refs.sidebarSearch.value = ''
        }, 100)
    },
    data () {
        return {
            appOptions: AppOptions,
            searchMenu: ''
        }
    },
    computed: {
        menus () {
            return this.getAllowedNavItems(SidebarMenu)
        },
        favoritesMenus() {
            return this.getFavoriteNavItems(SidebarMenu)
        }
    },
    methods: {
        getAllowedNavItems(navItems) {
            const menuFavorites = this.$store.state.authUser.menu_favorites
                ? this.$store.state.authUser.menu_favorites
                : [] // Favorites array
            let _allowNavItems = []

            for (let nav of navItems) {
                if (nav.children && nav.children.length > 0) {
                let _children = this.getAllowedNavItems(nav.children)

                if (_children.length > 0) {
                    _allowNavItems.push({
                    ...nav,
                    children: _children
                    })
                }
                }
                if (this.$store.state.authUser) {
                if (this.$store.state.authUser.permissions.includes(nav.permission)) {
                    _allowNavItems.push(
                    Object.assign(
                        {
                        is_favorite: menuFavorites
                            ? menuFavorites.includes(nav.path)
                            : false
                        },
                        nav
                    )
                    )
                }
                }
            }

            // return navItems
            return _allowNavItems
        },
        getFavoriteNavItems(navItems, isTopLevel = true) {
            const menuFavorites = this.$store.state.authUser.menu_favorites
                ? this.$store.state.authUser.menu_favorites
                : [] // Favorites array

            let favoriteChildren = []

            for (let nav of navItems) {
                // Recursively process child nodes
                if (nav.children && nav.children.length > 0) {
                favoriteChildren = favoriteChildren.concat(
                    this.getFavoriteNavItems(nav.children, false)
                )
                }

                // Add current item if it's a favorite
                if (menuFavorites.includes(nav.path)) {
                if (this.$store.state.authUser.permissions.includes(nav.permission)) {
                    favoriteChildren.push({
                    path: nav.path,
                    title: nav.title,
                    permission: nav.permission,
                    is_favorite: true
                    })
                }
                }
            }

            // Add the "favorites" wrapper only at the topmost level
            if (isTopLevel && favoriteChildren.length > 0) {
                return [
                {
                    title: 'menu.favorites',
                    icon: 'fas fa-star',
                    label: 'NEW',
                    class_icon_color: "bg-gradient-orange-red",
                    children: favoriteChildren
                }
                ]
            }

            return favoriteChildren
        },
        handleShowFloatSubmenu: function (menu, offset) {
            this.$emit('show-float-submenu', menu, offset)
        },
        handleHideFloatSubmenu: function () {
            this.$emit('hide-float-submenu')
        },
        handleCollapseOther: function (menu) {
            for (var i = 0; i < this.menus.length; i++) {
                this.$refs.sidebarNavList[i].collapse(menu)
            }
        },
        handleSidebarMinify: function () {
            this.appOptions.appSidebarMinified = !this.appOptions
                .appSidebarMinified
        },
        handleSidebarFilter(event) {
            const value = event.type === 'click'
                ? this.searchMenu.toLowerCase()
                : event.target.value.toLowerCase();

            const searchMenuRecursive = (menus, refList) => {
                let anyVisible = false;

                menus.forEach((menu, i) => {
                    const title = this.$t(menu.title).toLowerCase();
                    const children = menu.children || [];

                    const match = title.includes(value);
                    const childRefList = refList[i].$refs.sidebarNavList || [];

                    let childrenVisible = false;
                    if (children.length > 0) {
                        childrenVisible = searchMenuRecursive(children, childRefList);
                    }

                    if (match || childrenVisible) {
                        refList[i].show();
                        if (children.length > 0) {
                            refList[i].searchExpand();
                        }
                        anyVisible = true;
                    } else {
                        refList[i].hide();
                        children.forEach((_, j) => {
                            if (childRefList[j]) childRefList[j].hide();
                        });
                    }
                });

                return anyVisible;
            };

            if (value) {
                searchMenuRecursive(this.menus, this.$refs.sidebarNavList);
            } else {
                const showAllRecursive = (menus, refList) => {
                    menus.forEach((menu, i) => {
                        refList[i].show();
                        if (menu.children && menu.children.length > 0) {
                            refList[i].searchExpand();
                            const childRefList = refList[i].$refs.sidebarNavList || [];
                            showAllRecursive(menu.children, childRefList);
                        }
                    });
                };
                showAllRecursive(this.menus, this.$refs.sidebarNavList);
            }

            console.log('------');
        },

        handleCollapNav() {
            if (this.$refs.sidebarSearch.value.length == 0) {
                for (var i = 0; i < this.menus.length; i++) {
                this.$refs.sidebarNavList[i].collapse()
                this.$refs.sidebarNavList[i].handleCollapseOther()
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.form-control {
  background: none;
  border: none;
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid rgba(#ffff, 0.2);
  color: #ffff;
  border-radius: 0px;
}
.form-control:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.app-sidebar .menu .menu-search {
    padding: 10px 4px;
}
</style>
